// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ConnectBox popup: header (title + close), scrolling body, footer with the main action.
 * The host is the modal page (.ion-page, flex column). */
:host {
  font-family: var(--ion-font-family, inherit);
  background: var(--ion-background-color, #fff);
}

.cb-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex: 0 0 auto;
  padding: 16px 12px 12px 20px;
  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.cb-header h2 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.35;
}

.cb-icon-button {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium-shade);
  line-height: 0;
  cursor: pointer;
}
.cb-icon-button ion-icon {
  display: block;
  font-size: 21px;
}
.cb-icon-button:hover, .cb-icon-button:focus-visible {
  outline: none;
  background: rgba(var(--ion-color-medium-rgb), 0.12);
}

.cb-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 20px;
}

/* Step 1 */
.cb-form {
  display: grid;
  gap: 16px;
}
.cb-form ion-input {
  --border-radius: 10px;
  --highlight-color-focused: var(--ion-color-primary);
  min-height: 56px;
}

.cb-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cb-error {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0 4px;
  font-size: 12px;
  color: var(--ion-color-danger);
}
.cb-error ion-icon {
  flex-shrink: 0;
  font-size: 15px;
}

.cb-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 4px 0 0;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 13.5px;
  line-height: 1.5;
  color: var(--ion-color-step-800, #333);
  background: rgba(var(--ion-color-primary-rgb), 0.08);
}
.cb-notice ion-icon {
  flex-shrink: 0;
  font-size: 20px;
  color: var(--ion-color-primary);
}

/* Step 2: parameters, each with a copy button */
.cb-params {
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.2);
  border-radius: 12px;
  overflow: hidden;
}

.cb-param {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 10px 10px 14px;
}
.cb-param + .cb-param {
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);
}
.cb-param__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1 auto;
  min-width: 0;
}
.cb-param__label {
  font-size: 12px;
  color: var(--ion-color-medium-shade);
}
.cb-param__value {
  font-size: 14px;
  font-weight: 600;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  overflow-wrap: anywhere;
  -webkit-user-select: all;
          user-select: all;
}

.cb-copy {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  height: 32px;
  padding: 0 12px;
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.3);
  border-radius: 999px;
  background: transparent;
  color: var(--ion-color-primary);
  font: inherit;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.cb-copy ion-icon {
  font-size: 15px;
}
.cb-copy:hover, .cb-copy:focus-visible {
  outline: none;
  background: rgba(var(--ion-color-primary-rgb), 0.08);
}
.cb-copy--done {
  border-color: rgba(var(--ion-color-success-rgb), 0.4);
  color: var(--ion-color-success-shade);
  background: rgba(var(--ion-color-success-rgb), 0.1);
}

.cb-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 22px 0 10px;
  font-size: 14px;
  font-weight: 600;
}
.cb-section-title ion-icon {
  font-size: 18px;
  color: var(--ion-color-primary);
}

.cb-footer {
  display: flex;
  justify-content: flex-end;
  flex: 0 0 auto;
  padding: 12px 20px calc(12px + var(--ion-safe-area-bottom));
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.cb-footer__next {
  margin: 0;
  --border-radius: 10px;
  height: 42px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
}`, "",{"version":3,"sources":["webpack://./src/components/popup/popup-connect-box-management/popup-connect-box-management.component.scss"],"names":[],"mappings":"AAAA;yDAAA;AAEA;EACE,4CAAA;EACA,6CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,4BAAA;EACA,gEAAA;AACF;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;AAAF;AAEE;EACE,cAAA;EACA,eAAA;AAAJ;AAGE;EAEE,aAAA;EACA,mDAAA;AAFJ;;AAMA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;AAHF;;AAMA,WAAA;AACA;EACE,aAAA;EACA,SAAA;AAHF;AAKE;EACE,qBAAA;EACA,mDAAA;EACA,gBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AAJF;AAME;EACE,cAAA;EACA,eAAA;AAJJ;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sCAAA;EACA,oDAAA;AALF;AAOE;EACE,cAAA;EACA,eAAA;EACA,+BAAA;AALJ;;AASA,gDAAA;AACA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,wDAAA;EACA,mBAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,4BAAA;AANF;AAQE;EACE,6DAAA;AANJ;AASE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AAPJ;AAUE;EACE,eAAA;EACA,oCAAA;AARJ;AAWE;EACE,eAAA;EACA,gBAAA;EACA,qEAAA;EACA,uBAAA;EACA,wBAAA;UAAA,gBAAA;AATJ;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,yDAAA;EACA,oBAAA;EACA,uBAAA;EACA,+BAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kFAAA;AAVF;AAYE;EACE,eAAA;AAVJ;AAaE;EAEE,aAAA;EACA,oDAAA;AAZJ;AAeE;EACE,qDAAA;EACA,qCAAA;EACA,mDAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAdF;AAgBE;EACE,eAAA;EACA,+BAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,yBAAA;EACA,cAAA;EACA,2DAAA;EACA,6DAAA;AAfF;AAiBE;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AAfJ","sourcesContent":["/* ConnectBox popup: header (title + close), scrolling body, footer with the main action.\n * The host is the modal page (.ion-page, flex column). */\n:host {\n  font-family: var(--ion-font-family, inherit);\n  background: var(--ion-background-color, #fff);\n}\n\n.cb-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex: 0 0 auto;\n  padding: 16px 12px 12px 20px;\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n  h2 {\n    margin: 0;\n    font-size: 17px;\n    font-weight: 600;\n    line-height: 1.35;\n  }\n}\n\n.cb-icon-button {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium-shade);\n  line-height: 0;\n  cursor: pointer;\n\n  ion-icon {\n    display: block;\n    font-size: 21px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    background: rgba(var(--ion-color-medium-rgb), 0.12);\n  }\n}\n\n.cb-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n/* Step 1 */\n.cb-form {\n  display: grid;\n  gap: 16px;\n\n  ion-input {\n    --border-radius: 10px;\n    --highlight-color-focused: var(--ion-color-primary);\n    min-height: 56px;\n  }\n}\n\n.cb-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.cb-error {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin: 0 4px;\n  font-size: 12px;\n  color: var(--ion-color-danger);\n\n  ion-icon {\n    flex-shrink: 0;\n    font-size: 15px;\n  }\n}\n\n.cb-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 4px 0 0;\n  padding: 12px 14px;\n  border-radius: 12px;\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: var(--ion-color-step-800, #333);\n  background: rgba(var(--ion-color-primary-rgb), 0.08);\n\n  ion-icon {\n    flex-shrink: 0;\n    font-size: 20px;\n    color: var(--ion-color-primary);\n  }\n}\n\n/* Step 2: parameters, each with a copy button */\n.cb-params {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.2);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.cb-param {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 10px 10px 14px;\n\n  & + & {\n    border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  &__label {\n    font-size: 12px;\n    color: var(--ion-color-medium-shade);\n  }\n\n  &__value {\n    font-size: 14px;\n    font-weight: 600;\n    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n    overflow-wrap: anywhere;\n    user-select: all;\n  }\n}\n\n.cb-copy {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  flex-shrink: 0;\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.3);\n  border-radius: 999px;\n  background: transparent;\n  color: var(--ion-color-primary);\n  font: inherit;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n\n  ion-icon {\n    font-size: 15px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    background: rgba(var(--ion-color-primary-rgb), 0.08);\n  }\n\n  &--done {\n    border-color: rgba(var(--ion-color-success-rgb), 0.4);\n    color: var(--ion-color-success-shade);\n    background: rgba(var(--ion-color-success-rgb), 0.1);\n  }\n}\n\n.cb-section-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 22px 0 10px;\n  font-size: 14px;\n  font-weight: 600;\n\n  ion-icon {\n    font-size: 18px;\n    color: var(--ion-color-primary);\n  }\n}\n\n.cb-footer {\n  display: flex;\n  justify-content: flex-end;\n  flex: 0 0 auto;\n  padding: 12px 20px calc(12px + var(--ion-safe-area-bottom));\n  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n  &__next {\n    margin: 0;\n    --border-radius: 10px;\n    height: 42px;\n    font-weight: 600;\n    text-transform: none;\n    letter-spacing: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
